import React, { Component } from 'react';

class TextFieldNumber extends Component {

    handleChange = (event) => {
       const { value } = event.target
       
       if(this.props.caps){
        this.props.onChange(value.toUpperCase())
       }else{
        this.props.onChange(value)
       }
       
    }
    validate = (event) => {
        var controlKeys = [8, 9, 13, 37, 39, 46];
        var isControlKey = controlKeys.join(",").match(new RegExp(event.which));
        if (
          !event.which ||
          (48 <= event.which && event.which <= 57) ||
          isControlKey
        ) {
          return;
        } else {
          event.preventDefault();
        }
      };
    render() {
        return (
            <div className="TextFieldBlock">
                {this.props.label && (
                    <label htmlFor="app-input-field">{this.props.label} <label className="starcolor">{this.props.required&&"*"}</label></label>
                )}
                <input
                    disabled={this.props.disabled}
                    readOnly={this.props.readOnly}
                    type={this.props.type}
                    value={this.props.value}
                    className='TextField'
                    // placeholder={this.props.placeholder}
                    placeholder="Enter here"
                    onChange={this.handleChange}
                    InputProps={this.props.InputProps}
                    onKeyPress={this.validate}
                />

            </div>
        )
    }
}
export default TextFieldNumber